import React, { Component } from "react";
// import LoadingOverlay from "react-loading-overlay";

import "./App.css";

import Layout from "../../hoc/Layout/Layout";

import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";

import * as RouteLists from "../../hoc/Router/index";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { withRouter } from "react-router";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: true,
    };
  }

  componentDidMount() {
    this.setState({
      isActive: false,
    });
  }

  render() {
    let token = localStorage.getItem("token");

    if (token == null && this.props.history.location.pathname != "/login") {
      this.props.history.push("/login");
    }

    let routerList = RouteLists.RouteAll.map((key) => {
      return <Route key={key.name} path={key.path} render={key.render} />;
    });

    let routes = <Switch>{routerList}</Switch>;

    return (
      <Wrapper>
        {/*<LoadingOverlay active={this.state.isActive} spinner text="در حال بارگیری...">*/}
          <div className="App">
            <Layout>{routes}</Layout>

            <ToastContainer />
          </div>
        {/*</LoadingOverlay>*/}
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};

export default connect(mapStateToProps)(withRouter(App));
